import React, { useState } from "react";
import {
  Button,
  CircularProgress as CircularProgressComponent,
  Box,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { APIWatchersService } from "../../../../../../api";
import { timeAgo } from "../../../../../../utils/moment";

const UpdateAllTables = () => {
  const [updated, setUpdated] = useState<string>("");
  const [isUpdating, setIsUpdating] = useState(true);

  useQuery({
    queryKey: ["checkWatchersStatus"],
    async queryFn() {
      const response = await APIWatchersService.checkWatchersStatus();
      setIsUpdating(response.data.isWorking);
      setUpdated(response.data.updated.timestamp);
      return response;
    },
    refetchInterval: 10 * 1000,
    refetchOnWindowFocus: false,
  });

  const handleRunAllWatchers = async () => {
    try {
      setIsUpdating(true);
      const response = await APIWatchersService.runAllWatchers();
      setIsUpdating(response.data.isWorking);
      return response;
    } catch (error) {
      setIsUpdating(false);
      console.log("Error running all watchers:", error);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <Typography mr={1}>
        {isUpdating ? "Process is running ...." : <b>Updated {timeAgo(updated)}</b>}
      </Typography>
      <Button
        disabled={isUpdating}
        size="small"
        onClick={handleRunAllWatchers}
        endIcon={isUpdating && <CircularProgressComponent size={12} color="inherit" />}
      >
        Update data from Excel
      </Button>
    </Box>
  );
};

export default UpdateAllTables;
